const ListingData = {

  get store() {
    return Spruce.store('configurator')
  },

  getItemById(nid) {
    return this.store?.listingData.find((item) => item.nid === nid)
  }
}

export default ListingData
